'use client';
import SectionButton from '@hyphengroup/cms-components/components/SectionButton';
import React, { useCallback, useState } from 'react';

interface CollapsibleSectionProps {
  /** Header content (icon + title) */
  header: React.ReactNode;
  /** Main content displayed when expanded */
  children: React.ReactNode;
  /** Whether this section is initially open */
  defaultOpen?: boolean;
}

/**
 * Reusable collapsible section component with consistent styling and behavior.
 */
export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  header,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, [setIsOpen]);

  return (
    <div>
      <SectionButton
        isOpen={isOpen}
        showExpandIcon
        className="flex w-full items-center text-center"
        iconClassName="text-font-size/bullet-1 overflow-visible"
        toggleVisibility={handleToggle}
      >
        {header}
      </SectionButton>
      {isOpen && children}
    </div>
  );
};
